export default {
    0:'#F44336',
    1:'#FA8900',
    2:'#FFB300',
    3:'#4CAF50',
    4:'#00BCD4',
    5:'#2196F3',
    6:'#673AB7',
    7:'#A37361',
    8:'#000000',
  }